import { render, staticRenderFns } from "./GovernmentBondProducts.vue?vue&type=template&id=2aa8a725&scoped=true"
import script from "./GovernmentBondProducts.vue?vue&type=script&lang=ts&setup=true"
export * from "./GovernmentBondProducts.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./GovernmentBondProducts.vue?vue&type=style&index=0&id=2aa8a725&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa8a725",
  null
  
)

export default component.exports